export default "__VITE_ASSET__ZKyvePYC__"